<template>

  <div class="order-product-table">

    <div class="mb-2">
       <span class="mr-1">Cửa hàng:</span><b v-if="orderInfo.storeId">{{ orderInfo.storeName }}</b
      > <b v-else>Chưa được gán</b>
    </div>
     <b-row class="mb-5"
      > <b-col
        cols="2"
        class="pr-0"
        > <b-form-select
          class="select-style"
          v-model="productSearch.searchType"
          :options="optionProductSearchType"
          size="sm"
          value-field="id"
          text-field="name"
        ></b-form-select
        > </b-col
      > <b-col
        cols="10"
        class="pl-0"
        > <treeselect
          :load-options="loadOptionProducts"
          :multiple="false"
          :async="true"
          :placeholder="productSearch.placeHolder"
          :cache-options="false"
          retryText="Thử lại..."
          retryTitle="Nhấp thử lại"
          searchPromptText="Nhập để tìm kiếm..."
          loadingText="Đang tải..."
          noResultsText="Không có kết quả"
          openDirection="bottom"
          @select="onSelectProduct"
          :always-open="isOpenProductSearch"
          @search-change="onSearchChange"
          > <label
            slot="option-label"
            slot-scope="{ node, labelClassName }"
            :class="labelClassName"
            > <template
              >
              <div class="order-search-option d-flex align-items-start">
                 <ProductImage
                  :src="searchOptionImageUrl(node.raw)"
                  class="order-search-option__img object-contain flex-shrink-0"
                />
                <div class="order-search-option__body flex-grow-1 min-w-0">

                  <div class="order-search-option__row order-search-option__row--meta">
                     <span class="order-search-option__price">{{
                      convertPrice(node.raw.sellingPrice)
                    }}</span
                    > <span
                      class="order-search-option__stock"
                      :class="searchOptionStockQty(node.raw) > 0 ? 'text-success' : 'text-danger'"
                      >· TCB: {{ searchOptionStockQty(node.raw) }}</span
                    > <span
                      v-if="Number(node.raw.listedPrice) > 0"
                      class="order-search-option__listed text-muted"
                      >· Niêm yết: {{ convertPrice(node.raw.listedPrice) }}</span
                    > <span
                      v-if="searchOptionHasGifts(node.raw)"
                      class="order-search-option__gift badge badge-primary"
                      v-b-tooltip.hover
                      :title="searchOptionGiftTooltip(node.raw)"
                      ><i class="fas fa-gift"></i> Quà kèm</span
                    >
                  </div>

                  <div class="order-search-option__name text-dark"> {{ node.raw.label }} </div>

                  <div
                    v-if="node.raw.productCode"
                    class="order-search-option__code text-muted small"
                  >
                     {{ node.raw.productCode
                    }}<span v-if="node.raw.barCode"> · {{ node.raw.barCode }}</span
                    >
                  </div>
                   <span
                    v-if="node.raw.imeiCode && String(node.raw.imeiCode).trim().length > 0"
                    class="order-search-option__imei text-warning small"
                    >IMEI: {{ node.raw.imeiCode }}</span
                  >
                </div>

              </div>
               </template
            > </label
          > </treeselect
        > </b-col
      > </b-row
    >
    <table class="table table-bordered table-hover">

      <thead>

        <tr>

          <th
            class="header-color text-center"
            style="width: 5%"
          >
             STT
          </th>

          <th
            class="header-color text-center"
            style="width: 37%"
          >
             Sản phẩm
          </th>

          <th
            class="header-color text-center"
            style="width: 10%"
          >
             Số lượng
          </th>

          <th
            class="header-color text-center"
            style="width: 14%"
          >
             Giá
          </th>

          <th
            class="header-color text-center"
            style="width: 14%"
          >
             Chiết khấu
          </th>

          <th
            class="header-color text-center"
            style="width: 14%"
          >
             Thành tiền
          </th>

          <th style="width: 6%"></th>

        </tr>

      </thead>

      <tbody
        v-for="(productItem, index) in orderItems"
        :key="index"
      >

        <tr
          v-show="!productItem.deleted"
          class="heighRow"
        >

          <td
            class="td-middle text-center"
            style="width: 5%"
          >
             <span
              class="font-weight-bolder"
              v-if="isItemMainDisplay(productItem.orderItemType)"
              >{{ productItem.stt }}</span
            > <span v-else
              > <b-form-checkbox
                v-if="false"
                v-model="productItem.checked"
                size="lg"
                @change="checkValidation(productItem)"
                :disabled="!editable"
              ></b-form-checkbox
              > <i
                v-if="productItem.orderItemType === ITEM_TYPE.GIFT"
                class="fas fa-gift"
              ></i
              > <i
                v-if="productItem.orderItemType === ITEM_TYPE.ATTACH"
                class="fas fa-tags"
              ></i
              > </span
            >
          </td>

          <td
            style="width: 37%"
            :style="getAttachIndentStyle(productItem)"
          >

            <div class="d-flex align-items-center flex-gap-8">
               <!-- Hình ảnh sản phẩm --> <ProductImage
                :src="productItem.imageUrl"
                class="size-40 object-contain flex-shrink-0"
              /> <!-- Thông tin sản phẩm -->
              <div class="flex-grow-1 min-w-0">

                <p class="m-0 text-medium text-11 lh-1-4">
                   {{ flexComboHeaderBarCode(productItem) }}
                </p>

                <p class="m-0 text-medium text-12 lh-1-4">
                   {{ getTextProductCode(productItem) }}
                </p>

                <p class="m-0 font-weight-bolder lh-1-4">
                   {{ flexComboHeaderName(productItem) }}
                </p>
                 <b-input-group
                  v-if="productItem.productType === PRODUCT_TYPE.PRODUCT_IMEI"
                  class="row col-8 btn-imei"
                  > <b-form-input
                    size="sm"
                    v-model="productItem.imeiCode"
                    placeholder="Nhập mã IMEI"
                    :disabled="true"
                    autocomplete="off"
                  ></b-form-input
                  > <template #append
                    > <b-button
                      size="sm"
                      variant="secondary"
                      title="Danh sách IMEI"
                      class="font-weight-bolder"
                      v-b-tooltip.right
                      @click="addProductImei(productItem)"
                      > <i class="fas fa-list-ul text-dark"></i> </b-button
                    > </template
                  > <b-form-invalid-feedback :state="$v.itemChoice.imeiCode.minLength"
                    >Vui lòng nhập imei code > 3 kí tự</b-form-invalid-feedback
                  > <b-form-invalid-feedback :state="validate"
                    >Không đủ tồn kho sản phẩm</b-form-invalid-feedback
                  > </b-input-group
                >
                <div v-show="productItem.comboItems && productItem.comboItems.length">

                  <table class="table-responsive">

                    <tr
                      v-for="(items, index) in productItem.comboItems"
                      :key="index"
                      style="border-top: 1px solid gray"
                    >

                      <td style="border: none">
                         <i
                          style="color: rgb(24, 28, 50)"
                          class="fas fa-cube"
                        ></i
                        >
                      </td>

                      <td style="border: none; width: -webkit-fill-available">
                         {{ items.productName }} <i style="font-size: unset; color: unset"
                          >({{ convertPrice(items.sellingPrice) }})</i
                        >
                      </td>

                      <td style="border: none">{{ items.quantity }}</td>

                    </tr>

                  </table>

                </div>

                <div v-if="isItemMainDisplay(productItem.orderItemType)">

                  <div v-show="productItem.note || productItem.isPrivateNote">
                     <b-button
                      size="sm"
                      disabled
                      style="color: black; cursor: auto"
                      class="mr-1 font-italic btn-hidden"
                      :id="`popover-note-${index}`"
                      > Ghi chú: </b-button
                    > <span class="text-note"> {{ productItem.note }}</span
                    > <b-popover
                      ref="popover"
                      :target="`popover-note-${index}`"
                      placement="righttop"
                      > <template #title
                        > <b-button
                          @click="onHiddenPrivateNote(productItem, `popover-note-${index}`)"
                          class="close btn-hidden"
                          aria-label="Close"
                          style="background-color: transparent"
                          > <span
                            class="d-inline-block"
                            aria-hidden="true"
                            >&times;</span
                          > </b-button
                        > Sửa ghi chú sản phẩm </template
                      >
                      <div style="width: 200px">
                         <b-form-group
                          > <label>Ghi chú:</label> <b-form-textarea
                            size="sm"
                            class="input-style"
                            v-model="productItem.popPrivateNote"
                            :placeholder="'Thêm ghi chú'"
                            :rows="6"
                            :max-rows="6"
                          ></b-form-textarea
                          > </b-form-group
                        > <b-button
                          @click="onSavePrivateNote(productItem, `popover-note-${index}`)"
                          size="sm"
                          variant="primary"
                          class="mr-1"
                          >Lưu</b-button
                        > <b-button
                          @click="onHiddenPrivateNote(productItem, `popover-note-${index}`)"
                          size="sm"
                          variant="danger"
                          >Huỷ</b-button
                        >
                      </div>
                       </b-popover
                    >
                  </div>

                </div>

              </div>

            </div>

          </td>
           <!-- Số lượng -->
          <td
            class="td-middle text-center"
            style="width: 10%"
          >

            <div
              v-if="[ITEM_TYPE.GIFT, ITEM_TYPE.ATTACH].includes(productItem.orderItemType)"
              class="text-center"
            >
               {{ productItem.quantity }}
            </div>

            <div
              v-else-if="
                [PRODUCT_TYPE.PRODUCT, PRODUCT_TYPE.PRODUCT_COMBO].includes(
                  productItem.productType,
                ) ||
                (productItem.productType === PRODUCT_TYPE.PRODUCT_IMEI && isAllowUpdateQuantity)
              "
            >
               <BInputNumber
                v-if="editable"
                v-model="productItem.quantity"
                style="border-color: #007bff"
                placeholder="Số lượng"
                :inputClass="'w-100 text-right'"
                :disabled="!editable"
              />
            </div>

            <div
              v-else
              class="text-center"
            >
               {{ productItem.quantity }}
            </div>

          </td>
           <!-- Đơn giá -->
          <td class="td-middle text-right cell-with-hints">

            <div v-if="isItemMainDisplay(productItem.orderItemType)">

              <div v-if="checkPermissions(['BILL_EDIT_PRODUCT_PRICE'])">
                 <BInputNumber
                  v-if="editable"
                  v-model="productItem.sellingPriceMask"
                  style="border-color: #007bff"
                  placeholder="Đơn giá"
                  :inputClass="'w-100 text-right'"
                  :disabled="!editable"
                /> <span class="hint-label text-muted small"
                  > Giá sau giảm:<br /> {{ convertPrice(getPriceAfterDiscounts(productItem)) }}
                  </span
                >
              </div>

              <div
                v-else
                class="text-center"
              >
                 <span class="d-block"> {{ convertPrice(productItem.sellingPriceMask) }} </span>
                <span
                  v-if="productItem.orderItemType !== ITEM_TYPE.GIFT"
                  class="hint-label text-muted small"
                  > Giá sau giảm:<br /> {{ convertPrice(getPriceAfterDiscounts(productItem)) }}
                  </span
                >
              </div>

            </div>

            <div
              v-else
              class="text-center"
            >
               {{
                convertPrice(
                  productItem.sellingPriceMask != null && productItem.sellingPriceMask !== ''
                    ? productItem.sellingPriceMask
                    : productItem.sellingPrice,
                )
              }}
            </div>

          </td>
           <!-- Chiết khấu -->
          <td class="td-middle text-right cell-with-hints td-has-inline-input-group cell-discount">

            <div
              v-if="
                isItemMainDisplay(productItem.orderItemType) &&
                !productItem.flexibleComboId &&
                !productItem.voucherCode
              "
            >

              <div
                v-if="editable"
                class="discount-cell-stack"
              >
                 <b-input-group class="order-discount-input-group"
                  > <template #prepend
                    > <b-dropdown
                      :text="
                        productItem.discountType == DISCOUNT_AMOUNT_TYPE.MONEY
                          ? '$'
                          : productItem.discountType == DISCOUNT_AMOUNT_TYPE.PERCENT
                            ? '%'
                            : ''
                      "
                      size="sm"
                      variant="outline-primary"
                      class="order-discount-type-dd"
                      > <b-dropdown-item
                        @click="onChangeDiscountType(productItem, DISCOUNT_AMOUNT_TYPE.MONEY)"
                        >$</b-dropdown-item
                      > <b-dropdown-item
                        @click="onChangeDiscountType(productItem, DISCOUNT_AMOUNT_TYPE.PERCENT)"
                        >%</b-dropdown-item
                      > </b-dropdown
                    > </template
                  > <BInputNumber
                    v-model="productItem.discountAmount"
                    style="border-color: #007bff"
                    placeholder="Chiết khấu"
                    :inputClass="'order-discount-amount-input text-right'"
                    :disabled="!editable"
                    @change="checkValidation(productItem)"
                  /> </b-input-group
                > <span
                  v-if="rowHasPromotionLabel(productItem)"
                  v-b-tooltip.hover
                  :title="getPromotionTooltipText(productItem)"
                  class="label font-weight-bold label-lg label-inline label-light-success discount-ctkm-label"
                  >{{ getPromotionBadgeText(productItem) }}</span
                >
                <div
                  v-if="isShowMaxValueDescription(productItem)"
                  class="text-muted small discount-max-hint text-right"
                >
                   Chiết khấu vượt {{ productItem.originalPercentDiscountAmount }}%
                </div>
                 <b-form-invalid-feedback
                  class="discount-invalid-feedback"
                  :state="validateDiscountArr[productItem.id]"
                  > {{ messageErrorDiscount }} </b-form-invalid-feedback
                >
              </div>

              <div
                v-else
                class="text-center"
              >
                 {{ convertPrice(productItem.discountAmount) || '' }} ({{
                  DISCOUNT_AMOUNT_TYPE_NAME[productItem.discountType] || '$'
                }}) <span
                  v-if="rowHasPromotionLabel(productItem)"
                  v-b-tooltip.hover
                  :title="getPromotionTooltipText(productItem)"
                  class="label font-weight-bold label-lg label-inline label-light-success discount-ctkm-label discount-ctkm-label--center d-block mt-1"
                  >{{ getPromotionBadgeText(productItem) }}</span
                >
              </div>

            </div>

            <div
              v-else-if="
                isItemMainDisplay(productItem.orderItemType) &&
                !productItem.flexibleComboId &&
                lineHasStackedDiscount(productItem)
              "
            >

              <div
                class="discount-cell-stack"
                :class="{ 'discount-cell-stack--readonly-center': !editable }"
              >
                 <span class="d-block font-weight-bold">{{
                  convertPrice(stackedLineDiscountTotal(productItem))
                }}</span
                > <span class="hint-label text-muted small d-block"
                  >CTGG: {{ convertPrice(Number(productItem.discountProgramAmount) || 0) }}</span
                > <span class="hint-label text-muted small d-block"
                  >Voucher: {{ convertPrice(Number(productItem.voucherAmount) || 0) }}</span
                > <span
                  v-if="rowHasPromotionLabel(productItem)"
                  v-b-tooltip.hover
                  :title="getPromotionTooltipText(productItem)"
                  class="label font-weight-bold label-lg label-inline label-light-success discount-ctkm-label d-block mt-1"
                  >{{ getPromotionBadgeText(productItem) }}</span
                >
                <div class="d-flex justify-content-end mt-1">
                   <VoucherTag
                    :voucherCode="productItem.voucherCode"
                    v-on:removeTag="onRemoveVoucher(productItem)"
                  />
                </div>

              </div>

            </div>

            <div
              v-else-if="
                isItemMainDisplay(productItem.orderItemType) &&
                productItem.voucherCode &&
                !lineHasStackedDiscount(productItem)
              "
            >
               <span>{{ convertPrice(productItem.discountAmount) }}</span
              >
              <div class="d-flex justify-content-end">
                 <VoucherTag
                  :voucherCode="productItem.voucherCode"
                  v-on:removeTag="onRemoveVoucher(productItem)"
                />
              </div>

            </div>

            <div v-else-if="isItemMainDisplay(productItem.orderItemType)">
               <span>{{ convertPrice(productItem.discountAmount) }}</span
              >
            </div>

            <div
              v-else-if="[ITEM_TYPE.GIFT, ITEM_TYPE.ATTACH].includes(productItem.orderItemType)"
              class="child-row-discount text-right text-muted small"
            >
               <template v-if="childRowHasLineDiscount(productItem)"
                > <span class="d-block text-dark"
                  > {{ convertPrice(productItem.discountAmount) || 0 }} ({{
                    DISCOUNT_AMOUNT_TYPE_NAME[productItem.discountType] || '$'
                  }}) </span
                > <span
                  v-if="rowHasPromotionLabel(productItem)"
                  v-b-tooltip.hover
                  :title="getPromotionTooltipText(productItem)"
                  class="label font-weight-bold label-inline label-light-success discount-ctkm-label mt-1"
                  style="font-size: 0.75rem"
                  >{{ getPromotionBadgeText(productItem) }}</span
                > </template
              > <span v-else>—</span>
            </div>
             <span
              v-if="isItemMainDisplay(productItem.orderItemType)"
              class="hint-label text-muted small hint-label--order-discount"
              > Giảm tổng đơn:<br /> {{ convertPrice(getDistributedDiscount(productItem)) }} </span
            >
          </td>
           <!-- Thành tiền -->
          <td
            class="text-right cell-with-hints cell-total-amount td-middle"
            style="vertical-align: middle; padding-top: 10px"
          >

            <div
              v-if="isItemMainDisplay(productItem.orderItemType)"
              class="total-main-stack"
            >
               <span class="d-block font-weight-bold">{{
                convertPrice(calculateTotalAmountOrderItems(productItem))
              }}</span
              > <span class="hint-label text-muted small hint-label--order-total"
                >Sau tổng giảm:<br /> {{ convertPrice(getAmountAfterDiscounts(productItem)) }}
                </span
              >
            </div>

            <div
              v-else-if="[ITEM_TYPE.GIFT, ITEM_TYPE.ATTACH].includes(productItem.orderItemType)"
              class="total-child-stack"
            >
               <span class="d-block font-weight-bold">{{
                convertPrice(calculateTotalAmountOrderItems(productItem))
              }}</span
              >
              <div class="child-repurchase-block">
                 <span class="text-primary d-block small mb-1">{{
                  productItem.orderItemType === ITEM_TYPE.GIFT ? 'Giá thu lại' : 'Giá chiết khấu'
                }}</span
                > <BInputNumber
                  v-if="editable"
                  v-model="productItem.repurchasePrice"
                  style="border-color: #007bff"
                  :placeholder="
                    productItem.orderItemType === ITEM_TYPE.GIFT ? 'Giá thu lại' : 'Giá chiết khấu'
                  "
                  :inputClass="'w-100 text-right child-repurchase-input'"
                  :disabled="!editable"
                /> <span v-else>{{
                  productItem.quantity > 0 ? convertPrice(productItem.repurchasePrice) : 0
                }}</span
                >
              </div>
               <span
                v-if="productItem.orderItemType !== ITEM_TYPE.GIFT"
                class="hint-label text-muted small hint-label--order-total"
                >Sau tổng giảm:<br /> {{ convertPrice(getAmountAfterDiscounts(productItem)) }}
                </span
              >
            </div>

          </td>

          <td
            class="td-middle"
            style="width: 6%"
            v-if="editable"
          >

            <div class="d-flex justify-content-center">
               <b-dropdown
                size="sm"
                no-caret
                right
                v-if="productItem.orderItemType === 1"
                :disabled="!editable"
                > <template slot="button-content"
                  > <i
                    style="font-size: 1rem; padding-right: 0px"
                    class="flaticon2-settings"
                  ></i
                  > </template
                > <!-- <b-dropdown-item @click="addProductGift(productItem)"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem"
                      class="fas fa-gift"
                    ></i
                    > &nbsp; Thêm quà tặng </span
                  > </b-dropdown-item
                >  --> <b-dropdown-item
                  @click.prevent="addProductAttach(productItem)"
                  v-if="!blockAttachByInstallment"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem"
                      class="fas fa-tags"
                    ></i
                    > &nbsp; Thêm SP bán kèm </span
                  > </b-dropdown-item
                > <b-dropdown-item
                  v-if="!productItem.flexibleComboId && !productItem.voucherCode"
                  @click="addProductWarranty(productItem)"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem"
                      class="fas fa-shield-alt"
                    ></i
                    > &nbsp; Thêm gói bảo hành </span
                  > </b-dropdown-item
                > <b-dropdown-item
                  v-if="!productItem.voucherCode"
                  @click="addVoucher(productItem)"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem"
                      class="fas fa-ticket-alt"
                    ></i
                    > &nbsp; Thêm voucher </span
                  > </b-dropdown-item
                > <b-dropdown-item @click="onShowPrivateNote(productItem, `popover-note-${index}`)"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem"
                      class="flaticon2-notepad"
                    ></i
                    > &nbsp; Thêm ghi chú </span
                  > </b-dropdown-item
                > <b-dropdown-item @click="changeProduct(productItem, 'main')"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem"
                      class="flaticon2-add-1"
                    ></i
                    > &nbsp; Đổi sản phẩm </span
                  > </b-dropdown-item
                > <b-dropdown-item
                  @click="showDeleteAlert(productItem)"
                  v-if="!isKeepStock"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem; color: #d33"
                      class="flaticon2-rubbish-bin-delete-button"
                    ></i
                    > &nbsp; Xóa </span
                  > </b-dropdown-item
                > </b-dropdown
              > <b-dropdown
                :disabled="!editable"
                size="sm"
                no-caret
                right
                v-else-if="
                  productItem.orderItemType === ITEM_TYPE.ATTACH &&
                  resolveAttachLevel(productItem) === 1
                "
                > <template slot="button-content"
                  > <i
                    style="font-size: 1rem"
                    class="flaticon2-settings pr-0"
                  ></i
                  > </template
                > <b-dropdown-item
                  @click.prevent="addProductAttach(productItem)"
                  v-if="!blockAttachByInstallment"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem"
                      class="fas fa-tags"
                    ></i
                    > &nbsp; Thêm SP bán kèm </span
                  > </b-dropdown-item
                > <b-dropdown-item
                  @click="showDeleteAlert(productItem)"
                  v-if="!isKeepStock"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem; color: #d33"
                      class="flaticon2-rubbish-bin-delete-button"
                    ></i
                    > &nbsp; Xóa </span
                  > </b-dropdown-item
                > </b-dropdown
              > <b-dropdown
                :disabled="!editable"
                size="sm"
                no-caret
                right
                v-else
                > <template slot="button-content"
                  > <i
                    style="font-size: 1rem"
                    class="flaticon2-settings pr-0"
                  ></i
                  > </template
                > <b-dropdown-item
                  v-if="productItem.orderItemType === ITEM_TYPE.GIFT"
                  @click="changeProduct(productItem, 'gift')"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem"
                      class="flaticon2-add-1"
                    ></i
                    > &nbsp; Đổi quà tặng </span
                  > </b-dropdown-item
                > <b-dropdown-item
                  @click="showDeleteAlert(productItem)"
                  v-if="!isKeepStock"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem; color: #d33"
                      class="flaticon2-rubbish-bin-delete-button"
                    ></i
                    > &nbsp; Xóa </span
                  > </b-dropdown-item
                > </b-dropdown
              >
            </div>

          </td>

        </tr>

      </tbody>

      <tfoot>

        <tr>

          <th
            style="text-align: end"
            colspan="5"
          >
             Tổng :
          </th>

          <td style="text-align: right; padding: 0px 20px; font-weight: 600">
             {{ formattedTotalPrice }}
          </td>

          <td></td>

          <td></td>

        </tr>

      </tfoot>

    </table>
     <OrderItemsModal
      @receives="receiveProducts"
      @receives-imei="receiveProductsImei"
      :parent="parent"
      :mode="mode"
      :params="params"
    /> <BillAttachModal
      ref="order-attach-modal"
      :billItemId="attachModalBillItemId"
      :productName="attachModalProductName"
      :productId="attachModalProductId"
      :storeId="orderInfo && orderInfo.storeId"
      :attachDepth="attachModalDepth"
      :mainProductId="attachModalMainProductId"
      v-on:addAttach="onOrderAddAttach"
    /> <FlexibleComboModal
      ref="order-flexible-combo"
      :flexibleComboItem="flexibleComboItem"
      :storeId="orderInfo && orderInfo.storeId"
      v-on:addComboChild="addComboChild"
    /> <BillWarrantyModal
      ref="order-warranty-modal"
      :billItemId="itemChoice.id"
      :productName="itemChoice.productName"
      :productId="itemChoice.productId"
      v-on:addWarranty="addOrderWarranty"
    /> <VoucherApplyModal
      ref="apply-voucher-modal"
      :billItemId="itemChoice.billItemId"
      :productName="itemChoice.productName"
      :storeId="orderInfo && orderInfo.storeId"
      :productId="itemChoice.productId"
      :productAmount="itemChoice.productAmount"
      :customerMobile="(getOrderCustomerInfo && getOrderCustomerInfo.customerMobile) || ''"
      :discount-program-id="itemChoice.discountProgramId"
      v-on:applyVoucherItem="onApplyVoucherItem"
    />
  </div>

</template>

<script>
  import ApiService from '@/core/services/api.service'
  import {
    createDebouncedProductSearchExecutor,
    isProductSearchSkipped,
    searchByImeiForSale,
    searchProductsForSale,
    unwrapProductSearchData,
  } from '@/utils/productSearch'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
  import {
    PRODUCT_TYPE,
    ITEM_TYPE,
    MODAL_TYPE_UPSERT_ORDER,
    ORDER_STATUS,
    TYPE_ORDER,
    AMOUNT_TYPE,
    DISCOUNT_AMOUNT_TYPE,
  } from '@/utils/enum'
  import { DISCOUNT_AMOUNT_TYPE_NAME } from '@/utils/enum-name'
  import { sumBy } from 'lodash'
  import FlexibleComboModal from '@/view/components/bills/FlexibleComboModal.vue'
  import BillWarrantyModal from '@/view/components/bills/BillWarrantyModal.vue'
  import VoucherApplyModal from '@/view/components/voucher/VoucherApplyModal.vue'
  import VoucherTag from '@/view/components/voucher/VoucherTag.vue'
  import productDiscountMixin from '@/view/mixins/product-discount.mixin'
  import { TIME_TRIGGER } from '@/utils/constants'
  import { validationMixin } from 'vuelidate'
  import { minLength } from 'vuelidate/lib/validators'
  import OrderItemsModal from '@/view/components/order/OrderItemsModal'
  import BillAttachModal from '@/view/components/bills/BillAttachModal.vue'
  import ProductImage from '@/view/components/products/ProductImage.vue'
  import Swal from 'sweetalert2'
  import {
    makeToastFaile,
    makeToastSuccess,
    cloneDeep,
    convertPrice,
    unMaskPrice,
    currencyMask,
  } from '@/utils/common'
  import calculateMixin from '@/view/mixins/calculate.mixins'
  import { mapGetters } from 'vuex'
  import {
    PURGE_INSTALLMENT_PROGRAM,
    SET_INSTALLMENT_PROGRAM,
  } from '../../../core/services/store/modules/payment/payment-installment.module'
  import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue'
  import permissionMixin from '@/view/mixins/permission.mixin'
  import { RepositoryFactory } from '@/repositories/RepositoryFactory'
  import {
    getPromotionBadgeText,
    getPromotionTooltipText,
    rowHasPromotionLabel,
  } from '@/utils/discountProgramDisplay'
  import {
    applyStackedAmountsToLineDisplayFields,
    hasVoucherOnLine,
    roundMoneyToThousand,
    totalLineDiscountMoneyRounded,
    clearSplitAmountFields,
    setProgramOnlySplitAmounts,
    isStackedDiscountLine,
  } from '@/utils/voucherDiscountStack'
  import { collectProgramIds } from '@/utils/discountProgramStack'
  import {
    countAttachCascadeRemove,
    findMainProductIdForAttachRow,
    rebuildAttachTreeOrder,
    resolveAttachLevel,
  } from '@/view/components/bills/helpers/nestAttachItems'

  const SEARCH_TYPE = {
    PRODUCT: 1,
    IMEI: 2,
    FLEXIBLE_COMBO: 3,
  }

  export default {
    props: ['editable', 'otherParams'],
    mixins: [validationMixin, calculateMixin, permissionMixin, productDiscountMixin],
    validations: {
      itemChoice: {
        imeiCode: {
          minLength: minLength(3),
        },
      },
    },
    data() {
      return {
        AMOUNT_TYPE,
        DISCOUNT_AMOUNT_TYPE,
        DISCOUNT_AMOUNT_TYPE_NAME,
        ORDER_STATUS,
        ITEM_TYPE,
        PRODUCT_TYPE,
        productSearch: {
          searchType: SEARCH_TYPE.PRODUCT,
          placeHolder: 'Tìm kiếm theo tên, mã, mã vạch sản phẩm',
          searchName: null,
        },
        filteredOptionsProduct: [],
        orderItems: [],
        productItem: {},
        itemChoice: {
          id: null,
          name: '',
          productId: null,
          productName: '',
          imeiCode: '',
          price: 0,
          quantity: 0,
          discount: 0,
          totalPrice: 0,
          billItemId: null,
          productAmount: 0,
          discountProgramId: null,
        },
        isOpenProductSearch: false,
        productSearchTemp: null,
        money: {
          decimal: '.',
          thousands: '.',
          masked: false,
          precision: 0,
        },
        isKeepStock: false,
        watchTracker: [],
        mode: null,
        parent: null,
        params: {},
        orderInfo: null,
        validate: true,
        optionProductSearchType: [],
        mask: currencyMask,
        validateDiscountArr: [],
        messageErrorDiscount: 'CK vượt giá trị SP',
        flexibleComboItem: {
          name: '',
          id: null,
          code: '',
          discountAmount: 0,
          discountType: 1,
          listItem: [],
          applyCategories: [],
          applyProducts: [],
          billItemId: null,
        },
        attachModalBillItemId: null,
        attachModalProductName: '',
        attachModalProductId: null,
        attachModalDepth: 1,
        attachModalMainProductId: null,
      }
    },
    components: {
      Treeselect,
      OrderItemsModal,
      BillAttachModal,
      BInputNumber,
      ProductImage,
      FlexibleComboModal,
      BillWarrantyModal,
      VoucherApplyModal,
      VoucherTag,
    },
    watch: {
      getProducts: {
        handler(val) {
          this.orderItems = val
        },
        immediate: true,
      },
      'productSearch.searchType'(type) {
        const name = [
          '',
          'Tìm kiếm theo tên, mã, mã vạch sản phẩm',
          'Tìm kiếm theo mã imei',
          'Tìm kiếm theo bộ combo',
        ]
        this.productSearch.placeHolder = name[type] || name[1]
      },
      getOrderInfo: {
        handler(value) {
          this.orderInfo = value
          this.params.storeId = value.storeId
        },
        deep: true,
      },
    },
    created() {
      this.orderInfo = { ...this.getOrderInfo }
      this.params.storeId = this.orderInfo.storeId
      this.initialData()
      this._productSearchLoader = createDebouncedProductSearchExecutor(
        async (searchQuery, options) => {
          const type = this.productSearch.searchType
          return this.searchProductAPI(searchQuery, type, options)
        },
      )
    },
    beforeDestroy() {
      this._productSearchLoader?.cancel?.()
    },
    mounted() {},
    computed: {
      isAllowUpdateQuantity() {
        return (
          this.orderInfo &&
          [
            ORDER_STATUS.NEW,
            ORDER_STATUS.CONFIRMING,
            ORDER_STATUS.TRACKING,
            ORDER_STATUS.NO_CATCHED_PHONE,
            ORDER_STATUS.KEEP_DEPOSIT,
            ORDER_STATUS.CONFIRMED,
          ].includes(this.orderInfo.status)
        )
      },
      ...mapGetters([
        'getProducts',
        'getOrderInfo',
        'getOrderCustomerInfo',
        'getOrderDiscount',
        'getInstallmentInterestZero',
      ]),
      blockAttachByInstallment() {
        return Boolean(this.getInstallmentInterestZero)
      },
      formattedTotalPrice() {
        let totalPrice = 0
        this.orderItems.map((item) => {
          if (item.orderItemType !== ITEM_TYPE.GIFT) {
            const totalPriceItem = this.calculateTotalAmountOrderItems(item)
            totalPrice += totalPriceItem
          }
        })
        return convertPrice(totalPrice)
      },
      totalGrossAmount() {
        let total = 0
        this.orderItems.forEach((item) => {
          if (item.orderItemType !== ITEM_TYPE.GIFT) {
            total += this.calculateGrossItemTotal(item)
          }
        })
        return total
      },
      totalAfterIndividualDiscounts() {
        let total = 0
        this.orderItems.forEach((item) => {
          if (item.orderItemType !== ITEM_TYPE.GIFT) {
            total += this.calculateTotalAmountOrderItems(item)
          }
        })
        return total
      },
      totalOrderDiscountAmount() {
        const orderDiscount = this.getOrderDiscount || {}
        const discountAmount = Number(unMaskPrice(orderDiscount.discountAmount)) || 0
        const subtractPointAmount = Number(unMaskPrice(orderDiscount.subtractPointAmount)) || 0
        const discountType = orderDiscount.discountType || 1

        const regularDiscount = this.calculateDiscountAmount(
          discountAmount,
          discountType,
          this.totalGrossAmount,
          1,
        )

        return regularDiscount + subtractPointAmount
      },
      distributedDiscounts() {
        const discounts = {}
        const eligibleItems = this.orderItems.filter(
          (item) => item.orderItemType !== ITEM_TYPE.GIFT,
        )

        if (eligibleItems.length === 0 || this.totalOrderDiscountAmount === 0) {
          return discounts
        }

        const totalOrderDiscount = this.totalOrderDiscountAmount
        const orderGrossTotal = this.totalGrossAmount
        let distributedTotal = 0

        for (let i = 0; i < eligibleItems.length - 1; i++) {
          const item = eligibleItems[i]
          const itemGrossTotal = this.calculateGrossItemTotal(item)
          const proportionalDiscount = Math.round(
            (itemGrossTotal / orderGrossTotal) * totalOrderDiscount,
          )
          discounts[item.id] = proportionalDiscount
          distributedTotal += proportionalDiscount
        }

        if (eligibleItems.length > 0) {
          const lastItem = eligibleItems[eligibleItems.length - 1]
          discounts[lastItem.id] = totalOrderDiscount - distributedTotal
        }

        return discounts
      },
    },
    methods: {
      getPromotionBadgeText,
      getPromotionTooltipText,
      rowHasPromotionLabel,
      childRowHasLineDiscount(item) {
        const n = Number(unMaskPrice(item.discountAmount || 0))
        return n > 0 || rowHasPromotionLabel(item)
      },
      lineHasStackedDiscount(line) {
        return isStackedDiscountLine(line)
      },
      stackedLineDiscountTotal(line) {
        return (Number(line.discountProgramAmount) || 0) + (Number(line.voucherAmount) || 0)
      },
      calculateGrossItemTotal(item) {
        const sellingPrice = item.sellingPriceMask || 0
        const quantity = item.quantity || 0
        return Number(sellingPrice) * Number(quantity)
      },
      getDistributedDiscount(item) {
        if (item.orderItemType === ITEM_TYPE.GIFT) return 0
        return this.distributedDiscounts[item.id] || 0
      },
      getPriceAfterDiscounts(item) {
        if (item.orderItemType === ITEM_TYPE.GIFT) return 0
        const distributedDiscount = this.getDistributedDiscount(item)
        const distributedDiscountPerUnit = distributedDiscount / (item.quantity || 1)
        const unitPrice = Number(item.sellingPriceMask || 0)
        const discPerUnit = this.calculateDiscountAmount(
          Number(item.discountAmount || 0),
          item.discountType || AMOUNT_TYPE.MONEY,
          unitPrice,
        )
        const afterItemDisc = unitPrice - discPerUnit
        return Math.round(afterItemDisc - distributedDiscountPerUnit)
      },
      onChangeDiscountType(productItem, discountType) {
        productItem.discountType = discountType
        this.checkValidation(productItem)
      },
      isShowMaxValueDescription(productItem) {
        return productItem.isOverMaxValue === 1
      },
      getAmountAfterDiscounts(item) {
        if (item.orderItemType === ITEM_TYPE.GIFT) return 0
        const itemTotal = this.calculateTotalAmountOrderItems(item)
        const distributedDiscount = this.getDistributedDiscount(item)
        return itemTotal - distributedDiscount
      },
      searchOptionImageUrl(raw) {
        if (!raw) return ''
        return raw.productImageUrl || raw.imageUrl || ''
      },
      searchOptionStockQty(raw) {
        if (!raw) return 0
        const n = Number(raw.inStockQuantity ?? raw.quantityInStock ?? 0)
        return Number.isFinite(n) ? n : 0
      },
      searchOptionHasGifts(raw) {
        const a = raw?.gifts
        const b = raw?.giftProducts
        return (Array.isArray(a) && a.length > 0) || (Array.isArray(b) && b.length > 0)
      },
      searchOptionGiftTooltip(raw) {
        const list =
          Array.isArray(raw?.gifts) && raw.gifts.length ? raw.gifts : raw?.giftProducts || []
        if (!list.length) return ''
        return list
          .map((g) => g.productName || g.name || '')
          .filter(Boolean)
          .join(', ')
      },
      convertPrice,
      initialData() {
        this.optionProductSearchType.push(
          {
            id: 1,
            name: 'Tìm sản phẩm',
          },
          {
            id: 2,
            name: 'Tìm sản phẩm IMEI',
          },
          {
            id: 3,
            name: 'Tìm bộ combo',
          },
        )
      },
      isItemMainDisplay(value) {
        return value === ITEM_TYPE.MAIN ? true : false
      },
      isFlexibleComboMainRow(item) {
        return (
          item.orderItemType === ITEM_TYPE.MAIN &&
          item.flexibleComboId != null &&
          item.flexibleComboId !== '' &&
          Array.isArray(item.comboItems) &&
          item.comboItems.length > 0
        )
      },
      flexComboHeaderBarCode(item) {
        if (this.isFlexibleComboMainRow(item)) {
          return item.flexibleComboCode || item.productBarCode || ''
        }
        return item.productBarCode || ''
      },
      flexComboHeaderName(item) {
        if (this.isFlexibleComboMainRow(item)) {
          return item.flexibleComboName || item.productName || ''
        }
        return item.productName || ''
      },
      getTextProductCode(item) {
        let productCode = ''
        switch (item.orderItemType) {
          case ITEM_TYPE.MAIN: {
            if (this.isFlexibleComboMainRow(item)) {
              const code = item.flexibleComboCode || item.productCode
              productCode = code ? `(${code})` : ''
              break
            }
            if (item.productType !== PRODUCT_TYPE.PRODUCT_COMBO) {
              productCode = `(${item.productCode})`
            }
            break
          }
          case ITEM_TYPE.GIFT: {
            productCode = 'Quà tặng kèm'
            break
          }
          case ITEM_TYPE.ATTACH: {
            productCode = 'Sản phẩm bán kèm'
            break
          }
        }
        return productCode
      },
      changeProduct(item, action) {
        if (action === 'gift') {
          this.mode = MODAL_TYPE_UPSERT_ORDER.CHANGE_GIFT
        } else if (action === 'main') {
          this.mode = MODAL_TYPE_UPSERT_ORDER.CHANGE_MAIN
        }
        this.parent = item

        this.$bvModal.show('modal-edit-order-item')
      },
      addProductImei(item) {
        this.parent = item
        this.mode = MODAL_TYPE_UPSERT_ORDER.PRODUCT_IMEI
        this.params.orderItems = cloneDeep(this.orderItems)
        this.$bvModal.show('modal-edit-order-item')
      },
      addProductGift(item) {
        this.parent = item
        this.mode = MODAL_TYPE_UPSERT_ORDER.GIFT
        this.$bvModal.show('modal-edit-order-item')
      },
      addProductAttach(item) {
        this.attachModalBillItemId = item.id
        this.attachModalProductName = item.productName || item.name || ''
        this.attachModalProductId = item.productId
        const isFromAttach = item.orderItemType === ITEM_TYPE.ATTACH
        this.attachModalDepth = isFromAttach ? 2 : 1
        if (isFromAttach) {
          this.attachModalMainProductId =
            findMainProductIdForAttachRow(item, this.orderItems) || item.productId
        } else {
          this.attachModalMainProductId = item.productId
        }
        setTimeout(() => {
          if (this.$refs['order-attach-modal']) {
            this.$refs['order-attach-modal'].showModal()
          }
        }, TIME_TRIGGER)
      },
      onOrderAddAttach(attachs) {
        if (!attachs || !attachs.length || !this.attachModalBillItemId) {
          this.attachModalBillItemId = null
          this.attachModalProductName = ''
          this.attachModalProductId = null
          return
        }
        const parentId = this.attachModalBillItemId
        const parentIndex = this.orderItems.findIndex((row) => row.id === parentId)
        if (parentIndex < 0) {
          this.attachModalBillItemId = null
          this.attachModalProductName = ''
          this.attachModalProductId = null
          return
        }
        let childsCount = this.orderItems.filter(
          (row) => row.belongOrderDetailId === parentId,
        ).length

        attachs.forEach((item) => {
          const qty = Number(item.quantity || 1)
          let discountType = item.discountType
          if (String(discountType).toUpperCase() === 'PERCENT') {
            discountType = AMOUNT_TYPE.PERCENT
          } else if (String(discountType).toUpperCase() === 'MONEY') {
            discountType = AMOUNT_TYPE.MONEY
          } else {
            discountType = Number(discountType || AMOUNT_TYPE.MONEY)
          }
          let discountAmount = Number(item.discountValue || 0)
          if (discountType === AMOUNT_TYPE.MONEY && qty > 0) {
            discountAmount /= qty
          }
          const selling = Number(item.sellingPrice || 0)
          const finalPrice = Number(item.finalSellingPrice ?? selling)
          const attachLevel = item.attachLevel || this.attachModalDepth || 1
          const promotionProgramId = item.promotionProgramId || item.accessoryGroupId || null
          const row = {
            id: item.id,
            belongOrderDetailId: parentId,
            orderItemType: ITEM_TYPE.ATTACH,
            productId: item.productId,
            productName: item.productName,
            productCode: item.productCode,
            barCode: item.barCode,
            productBarCode: item.barCode,
            productType: item.productType || PRODUCT_TYPE.PRODUCT,
            imageUrl: item.productImageUrl,
            sellingPrice: selling,
            sellingPriceMask: selling,
            quantity: qty,
            discountType,
            discountAmount,
            promotionProgramCode: item.promotionProgramCode || item.accessoryGroupCode || '',
            promotionProgramName: item.promotionProgramName || '',
            promotionProgramId,
            attachLevel,
            hasNestedAttach: item.hasNestedAttach ?? false,
            repurchasePrice: finalPrice,
            imeiCode: '',
            note: '',
            checked: true,
            deleted: false,
            accessoryGroupId: item.accessoryGroupId || promotionProgramId,
            accessoryGroupCode: item.accessoryGroupCode || item.promotionProgramCode || '',
            discountProgramId: null,
            voucherId: null,
            voucherDetailId: null,
            voucherCode: null,
            flexibleComboId: null,
            isPrivateNote: false,
            popPrivateNote: '',
            comboItems: [],
          }
          const addIndex = parentIndex + childsCount + 1
          this.orderItems.splice(addIndex, 0, row)
          childsCount += 1
        })

        this.attachModalBillItemId = null
        this.attachModalProductName = ''
        this.attachModalProductId = null
        this.attachModalDepth = 1
        this.attachModalMainProductId = null
        this.reorderOrderItems()
        makeToastSuccess('Thêm sản phẩm bán kèm thành công')
      },
      reorderOrderItems() {
        const mains = this.orderItems.filter((item) => item.orderItemType === ITEM_TYPE.MAIN)
        const children = this.orderItems.filter((item) => item.orderItemType !== ITEM_TYPE.MAIN)
        const sorted = rebuildAttachTreeOrder(mains, children, {
          mainIdField: 'id',
          parentField: 'belongOrderDetailId',
          attachItemType: ITEM_TYPE.ATTACH,
          orderItemTypeField: 'orderItemType',
        })
        this.orderItems.splice(0, this.orderItems.length, ...sorted)
        this.numberedOrderItems()
      },
      getAttachIndentStyle(productItem) {
        if (productItem.orderItemType !== ITEM_TYPE.ATTACH) {
          return {}
        }
        const level = resolveAttachLevel(productItem)
        if (level === 2) {
          return { paddingLeft: '2.5rem' }
        }
        return { paddingLeft: '1.25rem' }
      },
      resolveAttachLevel,
      async showDeleteAlert(product) {
        const text = `Bạn muốn xoá sản phẩm ${product.productName} ra khỏi danh sách`
        const alert = await this.showWarningAlert(text)

        if (alert.isConfirmed) {
          const index = this.getIndexOrderItems(product.id)

          if (index > -1) {
            const removeCount = countAttachCascadeRemove(
              product.id,
              this.orderItems,
              'belongOrderDetailId',
            )
            this.orderItems.splice(index, removeCount)
            this.numberedOrderItems()
          }
        }
      },
      numberedOrderItems() {
        let count = 1
        return this.orderItems.map((item) => {
          if (item.orderItemType === ITEM_TYPE.MAIN) {
            item.stt = count
            count++
          }
          return item
        })
      },
      onSearchChange(searchQuery) {
        if (searchQuery.length > 1 && !this.isOpenProductSearch) {
          this.isOpenProductSearch = true
        } else if (searchQuery.length === 0) {
          this.isOpenProductSearch = false
        }
      },
      isAvailableQuantity: async function (value) {
        this.validate = false
        let dataResponse = {
          ...this.itemChoice,
          id: this.productItem.id,
          productId: this.productItem.productId,
          imeiCode: value,
          name: this.productItem.name,
          quantity: this.productItem.quantity,
          price: this.productItem.price,
          totalPrice: this.totalPriceOfProduct,
          discount: this.productItem.discount,
        }

        if (value === '') {
          this.$emit('update', dataResponse)
          return true
        }

        const params = {
          storeId: this.orderInfo.storeId,
          imei: this.itemChoice.imeiCode,
        }

        await ApiService.query('bills/check-valid-imei', {
          params,
        })
          .then((response) => {
            if (response.data.data) {
              this.validate = true
              this.$emit('checkValidImei', this.validate)
              this.$emit('update', dataResponse)
            }
            return this.validate
          })
          .catch(() => {
            this.$emit('checkValidImei', this.validate)
            this.$emit('update', dataResponse)
            return this.validate
          })

        return false
      },

      /**
       * Chuẩn hoá list SP từ product search (legacy `productSearch` vs `v1/product-search/*` giống Bill).
       */
      extractOrderSearchRows(result, type) {
        if (type === SEARCH_TYPE.FLEXIBLE_COMBO) {
          return result?.data || []
        }
        if (Array.isArray(result)) {
          return result
        }
        return result?.data || []
      },
      loadOptionProducts({ action, searchQuery, callback }) {
        if (action !== ASYNC_SEARCH) return
        this.productSearchTemp = searchQuery
        this._productSearchLoader.run(searchQuery, (error, result) => {
          if (error) {
            callback(error, [])
            return
          }
          const type = this.productSearch.searchType
          const rows = this.extractOrderSearchRows(result, type)
          const optionProduct = rows.map((element) => {
            const sellingPriceMask = this.getProductPriceByBillType(element)
            if (type === SEARCH_TYPE.IMEI) {
              return {
                id: this.$uuid.v4(),
                label: element.productName,
                imeiCode: element.imeiCode,
                ...element,
                sellingPriceMask,
              }
            }
            return {
              id: this.$uuid.v4(),
              label: element.productName,
              ...element,
              sellingPriceMask,
            }
          })
          callback(null, optionProduct)
        })
      },
      async searchProductAPI(searchQuery, type, options = {}) {
        switch (type) {
          case SEARCH_TYPE.PRODUCT:
            return this.fetchProduct(searchQuery, options)
          case SEARCH_TYPE.IMEI:
            return this.fetchProductImei(searchQuery, options)
          case SEARCH_TYPE.FLEXIBLE_COMBO:
            return this.fetchFlexibleCombo(searchQuery)
          default:
            return { data: [] }
        }
      },
      fetchFlexibleCombo(textSearch) {
        const storeId = this.orderInfo.storeId || null
        if (!storeId || isProductSearchSkipped(textSearch)) {
          if (!storeId) makeToastFaile('Chưa chọn cửa hàng')
          return Promise.resolve({ data: [] })
        }
        const params = {
          textSearch: textSearch ? textSearch.trim() : null,
          storeId,
        }
        return ApiService.query('v1/flexible-combo/search', { params }).then(({ data }) => {
          const raw = data.data || []
          const mapped = raw.map((product) => ({
            productId: product.id,
            productName: product.name,
            productCode: product.code,
            productNameVat: '',
            discountAmount: product.discountAmount,
            discountType: product.discountType,
            discountTypeName: product.discountTypeName,
            productType: 3,
            imeiCode: '',
            listAccessoryBonus: [],
            listAccessoryPromotion: [],
            quantityInStock: product.inStockQuantity || 0,
            listedPrice: 0,
            listItem: product.listItem,
            applyCategories: product.applyCategories,
            applyProducts: product.applyProducts,
          }))
          return { data: mapped }
        })
      },
      async fetchProduct(textSearch, options = {}) {
        this.listProduct = []
        const storeId = this.orderInfo.storeId || null
        const params = {
          searchText: textSearch,
          storeId,
        }
        const response = await searchProductsForSale(params, options)
        return { data: unwrapProductSearchData(response) }
      },
      async fetchProductImei(textSearch, options = {}) {
        this.listProduct = []
        const storeId = this.orderInfo.storeId || null
        if (!storeId) {
          makeToastFaile('Chưa chọn cửa hàng')
          return { data: [] }
        }
        const params = {
          searchText: textSearch,
          storeId,
        }
        const response = await searchByImeiForSale(params, options)
        return { data: unwrapProductSearchData(response) }
      },
      async onSelectProduct(node) {
        this.isOpenProductSearch = false
        if (this.productSearch.searchType === SEARCH_TYPE.FLEXIBLE_COMBO) {
          this.flexibleComboItem.name = node.productName
          this.flexibleComboItem.id = node.productId
          this.flexibleComboItem.code = node.productCode
          this.flexibleComboItem.discountAmount = node.discountAmount
          this.flexibleComboItem.discountType = node.discountType
          this.flexibleComboItem.listItem = node.listItem
          this.flexibleComboItem.applyCategories = node.applyCategories
          this.flexibleComboItem.applyProducts = node.applyProducts
          this.flexibleComboItem.billItemId = null
          setTimeout(() => {
            this.$refs['order-flexible-combo'].showModal()
          }, TIME_TRIGGER)
          return
        }

        let countStt = this.orderItems.filter(
          (item) => item.orderItemType === ITEM_TYPE.MAIN,
        ).length

        const [item, autoGifts] = this.handleOrderItemSelected(node, ++countStt)
        this.orderItems.push(item)
        this.autoSelectGiftOrders(autoGifts, item.id)
        await this.applyProductDiscountProgram(item, this.orderInfo.storeId)
      },
      addComboChild(result) {
        const gifts = result.gifts || []
        const countStt =
          this.orderItems.filter((i) => i.orderItemType === ITEM_TYPE.MAIN).length + 1
        const id = this.$uuid.v4()
        const row = {
          ...cloneDeep(result),
          id,
          orderItemType: ITEM_TYPE.MAIN,
          stt: countStt,
        }
        delete row.itemType
        delete row.billItemId
        delete row.gifts
        this.orderItems.push(row)
        this.autoSelectGiftOrders(gifts, row.id)
        this.applyProductDiscountProgram(row, this.orderInfo.storeId)
      },
      addProductWarranty(productItem) {
        this.itemChoice.id = productItem.id
        this.itemChoice.productId = productItem.productId
        this.itemChoice.productName = productItem.productName
        setTimeout(() => {
          this.$refs['order-warranty-modal'].showModal()
        }, TIME_TRIGGER)
      },
      addOrderWarranty(attachs) {
        const parentId = this.itemChoice.id
        let insertIdx = this.orderItems.findIndex((x) => x.id === parentId)
        if (insertIdx < 0) return
        let childCount = this.orderItems.filter((x) => x.belongOrderDetailId === parentId).length
        attachs.forEach((item) => {
          const finalPrice = Number(item.finalSellingPrice ?? item.sellingPrice ?? 0)
          const row = {
            id: this.$uuid.v4(),
            orderItemType: ITEM_TYPE.ATTACH,
            belongOrderDetailId: parentId,
            productId: item.productId,
            productName: item.productName,
            productCode: item.productCode,
            productBarCode: item.barCode,
            imageUrl: item.imageUrl,
            productType: item.productType,
            sellingPrice: finalPrice,
            sellingPriceMask: finalPrice,
            quantity: 1,
            discountType: item.discountType,
            discountAmount: 0,
            repurchasePrice: finalPrice,
            imeiCode: '',
            promotionProgramCode: item.warrantyProgramCode,
            promotionProgramName: item.warrantyProgramName || '',
            note: '',
            checked: item.checked,
          }
          this.orderItems.splice(insertIdx + 1 + childCount, 0, row)
          childCount++
        })
      },
      addVoucher(productItem) {
        this.itemChoice.productName = productItem.productName
        this.itemChoice.productId = productItem.productId
        this.itemChoice.productAmount = productItem.sellingPriceMask
        this.itemChoice.billItemId = productItem.id
        this.itemChoice.discountProgramId = productItem.discountProgramId ?? null
        setTimeout(() => {
          this.$refs['apply-voucher-modal'].showModal()
        }, TIME_TRIGGER)
      },
      async onApplyVoucherItem(voucherItem) {
        const line = this.orderItems.find((row) => row.id === this.itemChoice.billItemId)
        if (!line) return

        const customerInfo = this.getOrderCustomerInfo || {}
        const voucherRepo = RepositoryFactory.get('vouchers')
        const stackedIds = []

        const existingPeers = this.orderItems.filter(
          (row) => row.voucherId === voucherItem.voucherId && hasVoucherOnLine(row),
        )
        const peers = existingPeers.some((row) => row.id === line.id)
          ? existingPeers
          : [...existingPeers, line]
        peers.forEach((row) => collectProgramIds(row).forEach((id) => stackedIds.push(id)))
        collectProgramIds(line).forEach((id) => stackedIds.push(id))

        const uniqueStacked = [...new Set(stackedIds)]
        if (uniqueStacked.length) {
          const unit = Number(line.sellingPriceMask || line.sellingPrice || 0)
          const qty = Number(line.quantity || 1)
          const res = await voucherRepo.validateCoupon({
            couponCode: voucherItem.voucherCode,
            storeId: this.orderInfo.storeId,
            customerId: customerInfo.customerId,
            products: [
              {
                productId: line.productId,
                quantity: line.quantity,
                sellingPrice: unit,
              },
            ],
            totalAmount: unit * qty,
            stackedDiscountProgramIds: uniqueStacked,
          })
          if (res.status !== 1) {
            makeToastFaile(res.message)
            return
          }
        }

        const programSnapById = {}
        peers.forEach((row) => {
          programSnapById[row.id] =
            row.discountProgramId && Number(row.discountProgramId) > 0
              ? totalLineDiscountMoneyRounded(row)
              : 0
        })

        line.voucherCode = voucherItem.voucherCode
        line.voucherId = voucherItem.voucherId
        line.voucherDetailId = voucherItem.voucherDetailId

        if (!voucherItem.cumluativeValues || !voucherItem.cumluativeValues.length) {
          const qty = Number(line.quantity || 1)
          const programTotal = programSnapById[line.id] || 0
          if (line.discountProgramId) {
            const voucherTotal = roundMoneyToThousand(Number(voucherItem.voucherValue || 0) * qty)
            applyStackedAmountsToLineDisplayFields(line, programTotal, voucherTotal)
          } else {
            line.discountType = AMOUNT_TYPE.MONEY
            line.discountAmount = voucherItem.voucherValue
            clearSplitAmountFields(line)
          }
          line.voucherCumluativeValues = []
          this.$forceUpdate()
          return
        }

        const billItemVouchers = this.orderItems.filter(
          (billItem) => billItem.voucherId === voucherItem.voucherId,
        )
        const billItems = billItemVouchers.map((billItem) => ({
          ...billItem,
          quantity: Number(billItem.quantity),
        }))
        const totalQuantity = sumBy(billItems, 'quantity')
        const cumluativeValueFound = voucherItem.cumluativeValues.find(
          (cumluativeValue) =>
            cumluativeValue.quantityFrom <= totalQuantity &&
            totalQuantity <= cumluativeValue.quantityTo,
        )
        const voucherCumluativeValue = cumluativeValueFound
          ? cumluativeValueFound.cumulativeValue
          : 0
        for (const billItemVoucher of billItemVouchers) {
          const vu = this.calVoucherValue(
            AMOUNT_TYPE.PERCENT,
            voucherCumluativeValue,
            billItemVoucher.sellingPriceMask || billItemVoucher.sellingPrice,
          )
          billItemVoucher.discountAmount = vu
          billItemVoucher.discountType = AMOUNT_TYPE.MONEY
          billItemVoucher.voucherCumluativeValues = voucherItem.cumluativeValues

          const qtyV = Number(billItemVoucher.quantity || 1)
          const prog = programSnapById[billItemVoucher.id] || 0
          if (billItemVoucher.discountProgramId && Number(billItemVoucher.discountProgramId) > 0) {
            const voucherTot = roundMoneyToThousand(vu * qtyV)
            applyStackedAmountsToLineDisplayFields(billItemVoucher, prog, voucherTot)
          } else {
            clearSplitAmountFields(billItemVoucher)
          }
        }
        this.$forceUpdate()
      },
      calVoucherValue(voucherType, voucherValue, productAmount) {
        if (voucherType === AMOUNT_TYPE.MONEY) {
          return voucherValue
        }
        return (productAmount * voucherValue) / 100
      },
      async onRemoveVoucher(row) {
        const idx = this.orderItems.findIndex((item) => item.id === row.id)
        if (idx < 0) return
        const line = this.orderItems[idx]
        line.prevVoucherId = line.voucherId
        line.voucherId = null
        line.voucherDetailId = null
        line.voucherCode = ''
        line.voucherCumluativeValues = []
        clearSplitAmountFields(line)
        line.discountAmount = 0
        line.discountType = AMOUNT_TYPE.MONEY
        const storeId = this.orderInfo && this.orderInfo.storeId
        if (Number(line.discountProgramId) > 0 && storeId) {
          line.promotionProgramCode = ''
          line.promotionProgramName = ''
          line.originalPercentDiscountAmount = 0
          line.isOverMaxValue = 0
          const prevDp = line.discountProgramId
          line.discountProgramId = null
          await this.applyProductDiscountProgram(line, storeId)
          if (!line.discountProgramId) {
            line.discountProgramId = prevDp
            setProgramOnlySplitAmounts(line)
          }
        }
      },
      getProductPriceByBillType(product) {
        const sellingPrice = product.sellingPrice || 0
        if (this.orderInfo.orderType === TYPE_ORDER.WHOLESALE) {
          return product.wholesalePrice || sellingPrice
        }
        return sellingPrice
      },
      handleOrderItemSelected(item, stt) {
        const autoGifts = Array.isArray(item.gifts) ? [...item.gifts] : []
        const itemSelected = cloneDeep(item)
        delete itemSelected.gifts
        const sellingPrice = this.getProductPriceByBillType(item)

        item.sellingPrice = sellingPrice
        itemSelected.orderItemType = ITEM_TYPE.MAIN
        itemSelected.quantity = 1
        itemSelected.sellingPriceMask = sellingPrice
        itemSelected.stt = stt
        itemSelected.note = ''
        itemSelected.discountType = 1
        itemSelected.discountAmount = 0
        itemSelected.discountProgramId = null
        itemSelected.promotionProgramCode = ''
        itemSelected.promotionProgramName = ''
        itemSelected.discountProgramAmount = 0
        itemSelected.voucherAmount = 0
        itemSelected.voucherId = null
        itemSelected.voucherDetailId = null
        itemSelected.voucherCode = null
        itemSelected.flexibleComboId = null
        itemSelected.isPrivateNote = false
        itemSelected.popPrivateNote = ''
        itemSelected.comboItems =
          item.comboItems || item.productInCombos || item.listProductInCombo || []
        this.selectInstallmentProgram(item.programs)
        return [itemSelected, autoGifts]
      },
      /**
       * Giống BillProduct.autoSelectGift: thêm dòng quà từ API productSearch khi chọn SP chính.
       */
      autoSelectGiftOrders(gifts, parentOrderItemId) {
        if (!gifts || !gifts.length || !parentOrderItemId) {
          return
        }
        const parentIndex = this.orderItems.findIndex((row) => row.id === parentOrderItemId)
        if (parentIndex < 0) {
          return
        }
        let childsCount = this.orderItems.filter(
          (row) => row.belongOrderDetailId === parentOrderItemId,
        ).length

        gifts.forEach((g) => {
          const row = {
            id: this.$uuid.v4(),
            belongOrderDetailId: parentOrderItemId,
            orderItemType: ITEM_TYPE.GIFT,
            productId: g.productId,
            productName: g.productName,
            productCode: g.productCode,
            barCode: g.barCode,
            productBarCode: g.barCode,
            productType: g.productType,
            imageUrl: g.imageUrl || g.productImageUrl,
            sellingPrice: g.sellingPrice,
            sellingPriceMask: g.sellingPrice,
            quantity: g.quantity || 1,
            discountType: AMOUNT_TYPE.MONEY,
            discountAmount: 0,
            discountProgramId: null,
            voucherAmount: 0,
            discountProgramAmount: 0,
            promotionProgramCode: g.promotionProgramCode || '',
            promotionProgramName: g.promotionProgramName || '',
            voucherId: null,
            voucherDetailId: null,
            voucherCode: null,
            flexibleComboId: null,
            repurchasePrice: 0,
            imeiCode: '',
            note: '',
            checked: g.checked !== false,
            deleted: false,
            isPrivateNote: false,
            popPrivateNote: '',
            comboItems: [],
          }
          const addIndex = parentIndex + childsCount + 1
          this.orderItems.splice(addIndex, 0, row)
          childsCount += 1
        })
        this.numberedOrderItems()
      },
      checkValidation(productItem) {
        const unit = Number(productItem.sellingPriceMask || 0)
        const discVal = Number(unMaskPrice(productItem.discountAmount))
        let effectiveDisc = discVal
        if (productItem.discountType === AMOUNT_TYPE.PERCENT) {
          effectiveDisc = (unit * discVal) / 100
        }
        if (effectiveDisc > unit) {
          this.$set(this.validateDiscountArr, productItem.id, false)
        } else {
          this.$set(this.validateDiscountArr, productItem.id, true)
        }
      },
      receiveProducts(product) {
        switch (this.mode) {
          case MODAL_TYPE_UPSERT_ORDER.CHANGE_GIFT: {
            const changedProduct = product.childs ? product.childs[0] : null
            if (changedProduct) {
              const getProduct = (item) => item.id === product.id
              const productIndex = this.orderItems.findIndex(getProduct)
              const currentProductId = product.id
              changedProduct.id = currentProductId
              changedProduct.orderItemType = ITEM_TYPE.GIFT
              changedProduct.checked = true
              changedProduct.deleted = false
              this.$set(this.orderItems, productIndex, changedProduct)
            }
            break
          }
          case MODAL_TYPE_UPSERT_ORDER.CHANGE_MAIN: {
            const changedProduct = product.childs ? product.childs[0] : null
            if (changedProduct) {
              const getProduct = (item) => item.id === product.id
              const productIndex = this.orderItems.findIndex(getProduct)
              const currentProductId = product.id

              const newProduct = Object.assign(product, changedProduct)
              newProduct.sellingPriceMask = newProduct.sellingPrice
              newProduct.id = currentProductId
              this.orderItems.splice(productIndex, 1, newProduct)
            }
            break
          }
          case MODAL_TYPE_UPSERT_ORDER.ATTACH: {
            const childs = product.childs || []
            const getParent = (item) => item.id === product.id
            const countChilds = (item) => item.belongOrderDetailId === product.id

            const parentIndex = this.orderItems.findIndex(getParent)
            let childsCount = this.orderItems.filter(countChilds).length

            childs.map((child) => {
              const addIndex = parentIndex + childsCount + 1
              child.belongOrderDetailId = product.id
              child.orderItemType = ITEM_TYPE.ATTACH
              child.checked = true
              child.deleted = false
              this.orderItems.splice(addIndex, 0, child)
              childsCount++
            })
            break
          }
          default: {
            const childs = product.childs || []
            const getParent = (item) => item.id === product.id
            const countChilds = (item) => item.belongOrderDetailId === product.id

            const parentIndex = this.orderItems.findIndex(getParent)
            let childsCount = this.orderItems.filter(countChilds).length

            childs.map((child) => {
              const addIndex = parentIndex + childsCount + 1
              child.belongOrderDetailId = product.id
              child.orderItemType = ITEM_TYPE.GIFT
              child.checked = true
              child.deleted = false
              this.orderItems.splice(addIndex, 0, child)
              childsCount++
            })
            break
          }
        }
      },
      receiveProductsImei(product, remove) {
        const getParent = (item) => item.id === product.id
        const parentIndex = this.orderItems.findIndex(getParent)
        if (remove) {
          product.imeiCode = null
        } else {
          product.imeiCode = product.productImei.imeiCode
          product.sellingPrice = product.productImei.sellingPrice
        }
        this.parent = null
        this.$set(this.orderItems, parentIndex, product)
      },
      showWarningAlert: function (text) {
        return Swal.fire({
          title: 'Xoá sản phẩm!',
          text: text,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'rgb(221, 51, 51)',
          cancelButtonColor: '#E5EAEE',
          confirmButtonText: 'Đồng ý',
          cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
          reverseButtons: true,
          showClass: {
            popup: 'animate__animated animate__fadeInDown',
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp',
          },
        })
      },
      getIndexOrderItems(id) {
        const index = this.orderItems.findIndex((item) => item.id === id)
        if (index < 0) {
          makeToastFaile(`Không tìm thấy ${id} trong danh sách`)
          throw new Error(`Không tìm thấy ${id} trong danh sách`)
        }
        return index
      },
      onShowPrivateNote(item, ref) {
        for (let i = 0; i < this.orderItems.length; i++) {
          this.$root.$emit('bv::hide::popover', `popover-note-${i}`)
        }
        const index = this.getIndexOrderItems(item.id)
        item.isPrivateNote = true
        item.popPrivateNote = item.note
        this.$set(this.orderItems, index, item)
        setTimeout(() => {
          this.$root.$emit('bv::show::popover', ref)
        }, 300)
      },
      onHiddenPrivateNote(item, ref) {
        const index = this.getIndexOrderItems(item.id)
        item.isPrivateNote = false
        this.$root.$emit('bv::hide::popover', ref)

        setTimeout(() => {
          this.$set(this.orderItems, index, item)
        }, 300)
      },
      onSavePrivateNote(item, ref) {
        const index = this.getIndexOrderItems(item.id)
        item.note = item.popPrivateNote.trim()

        if (item.note) {
          this.$set(this.orderItems, index, item)
          this.$root.$emit('bv::hide::popover', ref)
          makeToastSuccess('Thêm ghi chú thành công')
        } else {
          makeToastSuccess('Ghi chú không có nội dùng')
          item.isPrivateNote = false
          this.$root.$emit('bv::hide::popover', ref)
          setTimeout(() => {
            this.$set(this.orderItems, index, item)
          }, 300)
        }
      },
      selectInstallmentProgram(programs) {
        if (programs && programs.length) {
          const firstChoiceProram = programs[0]
          if (firstChoiceProram) {
            this.$store.dispatch(SET_INSTALLMENT_PROGRAM, {
              installmentProgramId: firstChoiceProram.id,
              installmentProgramName: firstChoiceProram.name,
              monthNo: firstChoiceProram.monthNo,
              installmentProgramMonthNo: null,
              details: programs,
              installmentProgramPrepayPercent: null,
              prepayPercent: firstChoiceProram.prepayPercent,
              conversionFeePercent: firstChoiceProram.conversionFeePercent,
            })
          }
        } else {
          this.$store.dispatch(PURGE_INSTALLMENT_PROGRAM)
        }
      },
    },
  }
</script>

<style lang="scss">
  .order-product-table {
  .order-search-option {
    gap: 10px;
    padding: 4px 0;
    line-height: 1.35;
  }
  .order-search-option__img {
    width: 44px;
    height: 44px;
    border-radius: 4px;
    border: 1px solid #e4e6ef;
    background: #f5f8fa;
  }
  .order-search-option__row--meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 8px;
    font-size: 0.8125rem;
    margin-bottom: 2px;
  }
  .order-search-option__price {
    color: #3699ff;
    font-weight: 700;
  }
  .order-search-option__stock {
    font-weight: 600;
    white-space: nowrap;
  }
  .order-search-option__listed {
    font-size: 0.75rem;
    white-space: nowrap;
  }
  .order-search-option__gift {
    font-size: 0.7rem;
    font-weight: 600;
    padding: 2px 6px;
    vertical-align: middle;
  }
  .order-search-option__gift .fa-gift {
    margin-right: 3px;
    font-size: 0.65rem;
  }
  .order-search-option__name {
    font-size: 0.875rem;
    font-weight: 600;
    white-space: normal;
    word-break: break-word;
  }
  .order-search-option__code {
    margin-top: 1px;
  }
  .order-search-option__imei {
    display: block;
    margin-top: 2px;
  }
  .form-group {
    margin-bottom: 1rem;
  }
  table {
    width: 100%;
    table-layout: fixed;

    td {
      vertical-align: top;
      padding: 14px;
    }

    tbody tr {
      height: auto;
    }
  }
  .vue-treeselect__input-container {
    padding-top: 0px;
  }

  .vue-treeselect__control {
    border-radius: 0.28rem;
    border: 1px solid #ced4da;
    height: 2.5rem;
  }

  .vue-treeselect--has-value .vue-treeselect__multi-value {
    margin-bottom: 2px;
  }

  .header-color {
    color: rgb(24, 28, 50);
  }
  .text-note {
    font-size: 12px;
    font-style: italic;
    white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */
    white-space: -webkit-pre-wrap; /* Chrome & Safari */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    white-space: pre-wrap; /* CSS3 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
    word-break: break-word;
    white-space: normal;
  }
  .btn-hidden {
    padding: 0px;
    border: none;
    background-color: transparent !important;
  }
  .btn-imei .btn.btn-secondary {
    background-color: #cac9db;
    border-color: #ced4da;
  }
  .hint-label {
    position: absolute;
    right: 10px;
    white-space: nowrap;
    font-weight: 600;
    text-align: right !important;

    &.text-muted {
      color: #6c757d;
    }
  }

  .cell-with-hints {
    position: relative;
    width: 14%;

    &.price-cell {
      padding-top: 2px;
      padding-bottom: 2px;
    }
  }

  /* Chỉ căn block cho ô không dùng input-group (tránh làm vỡ $/% + ô nhập cùng hàng) */
  .td-middle:not(.td-has-inline-input-group) .input-number-wrapper,
  .td-middle:not(.td-has-inline-input-group) .form-control {
    margin: 0 auto;
    display: block;
  }

  .td-middle {
    text-align: center;
    vertical-align: middle;
    padding-top: 10px;
    padding-bottom: 10px;
    align-content: center;
  }

  .td-middle.text-center span,
  .td-middle.text-center div {
    text-align: center;
  }

  .cell-discount.td-middle.text-right {
    text-align: right;
    min-width: 0;
  }

  .discount-cell-stack {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    width: 100%;
    max-width: 13rem;
    min-width: 0;
    margin-left: auto;
    text-align: right;
  }

  .discount-cell-stack--readonly-center {
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .discount-cell-stack--readonly-center .discount-ctkm-label {
    text-align: center;
  }

  .order-discount-input-group {
    width: 100%;
    flex-wrap: nowrap;
    align-items: stretch;
  }

  .order-discount-input-group ::v-deep .input-group-prepend {
    margin-right: 0;
  }

  .order-discount-type-dd {
    flex-shrink: 0;
  }

  .order-discount-type-dd ::v-deep .btn {
    min-width: 2.25rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .order-discount-input-group ::v-deep .input-number-wrapper {
    flex: 1 1 auto;
    min-width: 0;
    margin: 0;
    display: flex;
    align-items: stretch;
  }

  .order-discount-input-group ::v-deep .order-discount-amount-input,
  .order-discount-input-group ::v-deep .form-control {
    display: block;
    width: 100% !important;
    min-width: 0;
    text-align: right;
  }

  .discount-ctkm-label {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    display: block;
    text-align: right;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .discount-ctkm-label--center {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  .child-row-discount .discount-ctkm-label {
    max-width: 100%;
  }

  .discount-max-hint {
    width: 100%;
    line-height: 1.2;
    padding-bottom: 2px;
  }

  .discount-invalid-feedback {
    width: 100%;
    text-align: right;
  }

  .hint-label--order-discount {
    top: auto;
    bottom: 6px;
    margin-top: 8px;
    position: relative;
    right: auto;
    display: block;
    text-align: right !important;
    white-space: normal;
    font-weight: 600;
    line-height: 1.25;
    padding-top: 4px;
  }

  .hint-label--order-discount.text-muted {
    color: #6c757d !important;
    font-weight: 600;
  }

  .hint-label--order-total {
    position: relative;
    top: auto;
    right: auto;
    display: block;
    margin-top: 6px;
    text-align: right !important;
    white-space: normal;
    font-weight: 600;
    line-height: 1.25;
  }

  .hint-label--order-total.text-muted {
    color: #6c757d !important;
  }

  .total-main-stack,
  .total-child-stack {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 100%;
    max-width: 100%;
  }

  .child-repurchase-block {
    width: 100%;
    max-width: 12rem;
    margin-top: 6px;
  }

  .cell-total-amount {
    vertical-align: middle !important;
  }

  .child-row-discount {
    min-height: 2rem;
  }

  tfoot {
    th,
    td {
      text-align: center;
    }
  }
  @media (max-width: 768px) {
    table {
      font-size: 0.9em;

      td {
        padding: 6px;
      }
    }

    .hint-label.small {
      font-size: 0.75rem;
    }
  }
}
</style>

